module.exports = __webpack_public_path__ + "img/SMT_30_Mr_Choo_Jui_Sheng.70017cc2.jpg";